import { css } from "styled-components";
import token from "styled-token";
import { spacingMixin } from "../spacingMixin";
import { spaceMixin } from "../spaceMixin";
import { typographyMixin } from "../typographyMixin";
import { StyledIcon } from "../../components/Icon/Icon";

var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  return token({
    iconColor: "status." + appearance + ".foreground",
    errorColor: "status.error.fontColor"
  }, function (tokens) {
    var styles = [css(["> ", ":first-child{color:", ";}"], StyledIcon, tokens.iconColor)];

    if (appearance === "error") {
      styles.push("color: " + tokens.errorColor + ";");
    }

    if (appearance === "transient") {
      styles.push("font-style: italic;");
    }

    return styles;
  })(props);
};
/** @class InlineFeedbackMixin */

/** @method */


export var InlineFeedbackMixin = function InlineFeedbackMixin(props) {
  return token({
    fontType: "status.fontType",
    iconSize: "status.iconSize"
  }, function (_ref) {
    var fontType = _ref.fontType,
        iconSize = _ref.iconSize;
    return css(["margin:0;", " ", " ", " padding-left:", "px;position:relative;> ", ":first-child{position:absolute;top:0;left:0;height:", "px;width:", "px;margin-top:0;}"], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), spacingMixin(props), appearanceCSS(props), spaceMixin("sm", function (space) {
      return space.value + iconSize;
    })(props), StyledIcon, iconSize, iconSize);
  });
};